/**
 * Fix pour l'erreur "Cannot read properties of undefined (reading 'classList')"
 * 
 * Ce fichier contient des correctifs pour les bugs connus d'Ionic.
 */

// Patch pour la fonction isViewVisible
export function applyIonicPatches() {
  console.log('[Ionic Fix] Applying patches for Ionic bugs');
  
  // Patch global pour la fonction isViewVisible
  if (window.isViewVisible) {
    console.log('[Ionic Fix] Patching isViewVisible function');
    const originalIsViewVisible = window.isViewVisible;
    window.isViewVisible = (enteringEl) => {
      // Vérifier si enteringEl est défini avant d'accéder à classList
      if (!enteringEl || !enteringEl.classList) {
        console.log('[Ionic Fix] Prevented error: enteringEl is undefined');
        return false;
      }
      return originalIsViewVisible(enteringEl);
    };
  }
  
  // Patch pour handlePageTransition si nécessaire
  if (window.handlePageTransition) {
    console.log('[Ionic Fix] Patching handlePageTransition function');
    const originalHandlePageTransition = window.handlePageTransition;
    window.handlePageTransition = (...args) => {
      try {
        return originalHandlePageTransition(...args);
      } catch (error) {
        console.error('[Ionic Fix] Caught error in handlePageTransition:', error);
        return false;
      }
    };
  }
}
